import { render, staticRenderFns } from "./NotesIcon.vue?vue&type=template&id=67dcf303&scoped=true&"
import script from "./NotesIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NotesIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcf303",
  null
  
)

export default component.exports